import { useQuery } from '@tanstack/react-query';
import { adminKeys } from '../api/organizations';
import { fetchPlans } from '../api/plans';
import { isPlanlessOrgType } from '../utils/planDisplay';

/**
 * The plan catalogue for one entity type — the source for every plan dropdown.
 *
 * `staleTime: Infinity`: plans are seeded reference data that changes only on a
 * deploy, so refetching per dialog open is pure waste.
 *
 * `enabled` gates on `type` because consultants have no plans at all (phase 2) —
 * asking for their catalogue is a 400, and firing that request every time a
 * consultant's row is selected would fill the console with errors for a control
 * that is disabled anyway.
 */
export const useAdminPlans = (type) =>
  useQuery({
    queryKey: adminKeys.plans(type),
    queryFn: () => fetchPlans(type),
    enabled: Boolean(type) && !isPlanlessOrgType(type),
    staleTime: Infinity,
  });

export default useAdminPlans;
